import { render, staticRenderFns } from "./MultipleAttentionChannels.vue?vue&type=template&id=0da40f4e&scoped=true"
import script from "./MultipleAttentionChannels.vue?vue&type=script&lang=js"
export * from "./MultipleAttentionChannels.vue?vue&type=script&lang=js"
import style0 from "./MultipleAttentionChannels.vue?vue&type=style&index=0&id=0da40f4e&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0da40f4e",
  null
  
)

export default component.exports